import { useMemo } from "react";
import { useMainStore } from "@/stores";
import { useAppMode } from "@/shared/hooks/useAppMode";
import { useSidebarBadges } from "@/shared/components/layout/Sidebar/useSidebarBadges";
import { getMobileBottomNavItems } from "@/shared/utils/navigationConfig";
import MobileNavItem from "./MobileNavItem";

/** Matches tab bar content height — keep in sync with MainAppLayout mobile padding. */
export const MOBILE_TAB_BAR_HEIGHT = 56;

const MobileBottomNav = () => {
  const { user } = useMainStore();
  const { isAdminMode, isOrgAdmin } = useAppMode();
  const badgeCounts = useSidebarBadges();

  const navItems = useMemo(
    () => getMobileBottomNavItems({ user, isAdminMode, isOrgAdmin }),
    [user, isAdminMode, isOrgAdmin],
  );

  if (navItems.length === 0) return null;

  return (
    <nav
      aria-label="Main navigation"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-gray-200 bg-white md:hidden"
      style={{
        paddingBottom: "env(safe-area-inset-bottom, 0px)",
      }}
    >
      <div
        role="tablist"
        aria-orientation="horizontal"
        className="mx-auto flex h-14 max-w-screen-sm items-stretch"
      >
        {navItems.map((nav) => (
          <MobileNavItem
            key={nav.id}
            navLink={nav}
            badge={badgeCounts[nav.title]}
          />
        ))}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
